import type { SetupApiIntent, ApiPaymentMethod } from "@/Modules/Models/Api/Payment";
import type {
  PaymentDefaultApiQuery,
  PaymentDeleteApiQuery,
  PaymentIntentApiQuery,
  PaymentApiBillingInfo,
} from "@/Modules/Models/Api/Payment";

import { get2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export function setupIntentMethod(): Promise<SetupApiIntent> {
  return get2<void, SetupApiIntent>("v1.0/payments_methods/setup_intent");
}

export function getUserPaymentMethods(uuid: string): Promise<ApiPaymentMethod[]> {
  return get2<void, ApiPaymentMethod[]>("v1.0/payments_methods/stripe?user_id=" + uuid);
}

export function setDefaultPaymentMethod(uuid: string, paymentMethodId: string): Promise<ApiPaymentMethod> {
  return post2<PaymentDefaultApiQuery, ApiPaymentMethod>("v1.0/payments_methods/stripe/default", {
    user_id: uuid,
    card_id: paymentMethodId,
  });
}

export function deletePaymentMethod(uuid: string, paymentMethodId: string): Promise<void> {
  return remove2<PaymentDeleteApiQuery, void>("v1.0/payments_methods/stripe", {
    card_stripe_id: paymentMethodId,
    customer_uuid: uuid,
  });
}

export function attachPaymentMethod(intentId: string): Promise<PaymentApiBillingInfo> {
  return post2<PaymentIntentApiQuery, PaymentApiBillingInfo>("v1.0/payments_methods/attach_payment_method", {
    intent_id: intentId,
  });
}
